import VirtualizedCheckbox from './virtualized-checkbox';
export default VirtualizedCheckbox;